module.exports = __webpack_public_path__ + "img/31.d0860923.svg";